// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__Zqh6L","load2":"Spinner_load2__OANbB"};